import { CLIENT } from '@/clients';

/**
 * Rewrites the brand baked into the shared copy.
 *
 * The locale tables were written for 99h and name it in 156 places across
 * the six languages — the About, Privacy and Terms pages are almost nothing
 * but. Those tables are shared by every client, so editing them would
 * rebrand 99h itself; a client that ships under another name declares
 * `copyBrandName` instead and the substitution happens on the way out of
 * `t()`.
 *
 * What is deliberately NOT rewritten:
 *  - Email addresses. `support@99h.com` is a real mailbox, and swapping the
 *    domain would produce an address that does not exist. The `[^@\w.]`
 *    guard before the match is what keeps it whole.
 *  - Provider names like `99H体育`. Those live in PROVIDER_TITLE, not in the
 *    locale tables, so they never reach this function.
 */
/**
 * The trailing guard is an explicit character class, NOT `\b`. JavaScript's
 * `\b` is ASCII-only, so it sees a boundary between `H` and a Chinese
 * character and would turn a name like `99H体育` into `东风国际体育`. The second
 * lookahead stops `99h` being pulled out of the middle of `99h.com` while
 * still allowing a sentence-ending period, as in "...options for you at
 * 99h.com."
 */
const LEGACY_BRAND = /(^|[^@\w.])99h(\.com)?(?![\w\u4e00-\u9fff])(?!\.\w)/gi;

export function rebrand(text: string): string {
  const brand = CLIENT.copyBrandName;
  // Cheap reject first: this runs on every translated string.
  if (!brand || (!text.includes('99h') && !text.includes('99H'))) return text;
  return text.replace(LEGACY_BRAND, (_m, before: string) => before + brand);
}
